<template>
  <div>
    <el-row>
      <el-col :span="12">
<!--        接口-->
        <el-table :data="tableData" style="width: 100%;overflow: auto" @row-click="rowClick"  max-height="89vh">
          <el-table-column align="center" prop="id" label="ID" width="50"></el-table-column>
          <el-table-column align="center" prop="name" label="名称" show-overflow-tooltip></el-table-column>
          <el-table-column align="center" prop="method" label="请求方式" width="100"></el-table-column>
          <el-table-column align="center" prop="signature" label="接口签名" show-overflow-tooltip></el-table-column>
        </el-table>
      </el-col>
      <el-col :span="12">
        <div v-if="currentFunId">
<!--          菜单-->
          <div>
            <span style="margin-left: 10px;font-size: 18px;font-weight: bolder;color: #504d4d">菜单</span>
            <el-button @click="bindClick('菜单')" size="mini" type="primary" style="margin-right: 10px;float: right">绑定菜单</el-button>
            <el-table :data="menuData" style="width: 100%">
              <el-table-column align="center" prop="id" label="ID" width="50"></el-table-column>
              <el-table-column align="center" prop="name" label="名称" show-overflow-tooltip></el-table-column>
              <el-table-column align="center" prop="route" label="路由" width="300" show-overflow-tooltip></el-table-column>
            </el-table>
          </div>
<!--          按钮-->
          <div style="margin-top: 20px">
            <span style="margin-left: 10px;font-size: 18px;font-weight: bolder;color: #504d4d;margin-top: 10px">按钮</span>
            <el-button @click="bindClick('按钮')" size="mini" type="primary" style="margin-right: 10px;float: right">绑定按钮</el-button>
            <el-table :data="buttonData" style="width: 100%">
              <el-table-column align="center" prop="id" label="ID" width="50"></el-table-column>
              <el-table-column align="center" prop="alias" label="名称" show-overflow-tooltip></el-table-column>
              <el-table-column align="center" prop="name" label="字段名称" width="300" show-overflow-tooltip></el-table-column>
            </el-table>
          </div>

        </div>

      </el-col>
    </el-row>


    <el-dialog title="绑定" :visible.sync="bindView" width="300px"  append-to-body>
      <div style="text-align: center;">
        <el-input placeholder="填写需要绑定的ID,用逗号( , )隔开" style="width:250px;" v-model="bindValue"></el-input>
      </div>
      <div style="text-align: center;margin-top: 20px">
        <el-button type="primary" @click="saveBind" size="small">保 存</el-button>
        <el-button  @click="bindView = false" size="small">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "Interface",
  data() {
    return {
      tableData: [],
      menuData: [],
      buttonData: [],
      authorities: [],
      bindView: false,
      bindValue: "",
      bindFlag: null,
      currentFunId: ""
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.$axios.get(this.baseUrl3 + "function/findAll")
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (data && data.length > 0) {
              this.tableData = data;
            } else {
              this.tableData = [];
            }
          } else {
            this.$message({showClose: true, message: msg, type: "error"})
          }
        }).catch(err => {
        this.$message.error('请求失败');
        console.log(err)
      });
    },
    getMenuAndButton() {
      this.$axios.get(this.baseUrl3 + "function/findById/" + this.currentFunId)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (data) {
              if (data.buttonList && data.buttonList.length > 0) {
                this.buttonData = data.buttonList
              } else {
                this.buttonData = []
              }
              if (data.appList && data.appList.length > 0) {
                this.menuData = data.appList
              } else {
                this.menuData = []
              }
            }
          } else {
            this.$message({showClose: true, message: msg, type: "error"})
          }
        }).catch(err => {
        this.$message.error('请求失败');
        console.log(err)
      });
    },
    rowClick(row) {
      this.currentFunId = row.id;
      this.getMenuAndButton();
    },
    bindClick(flag) {
      this.bindValue="";
      this.bindView = true;
      this.bindFlag = flag
    },
    saveBind() {
      let data = {};
      let url = "";
      if (this.bindFlag == "菜单") {
        data = {
          funId: this.currentFunId,
          appIds: this.bindValue.split(",").map(Number)
        }
        url = this.baseUrl3 + "function/bindApp"
      } else {
        data = {
          funId: this.currentFunId,
          buttonIds: this.bindValue.split(",").map(Number)
        }
        url = this.baseUrl3 + "function/bindButton"
      }
      this.$axios.post(url, data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.bindView = false;
            this.getMenuAndButton()
          } else {
            this.$message({showClose: true, message: msg, type: "error"})
          }
        }).catch(err => {
        this.$message.error('请求失败');
        console.log(err)
      });
    },

  }
}
</script>

<style scoped>

</style>
